import coachGinge from './coach-ginge';
import quietBamboo from './quiet-bamboo';
import farshore from './farshore';
import theChinaYouHaventSeen from './the-china-you-havent-seen';
import farshorePlaytest from './farshore-playtest';
import quietBambooUpdate from './quiet-bamboo-update';
import podbrowser from './podbrowser';
import vertigo from './vertigo';
import coachGingeForKids from './coach-ginge-for-kids';
import coachGingeHalloween from './coach-ginge-halloween';
import coachGingeToyBoxTales from './coach-ginge-toy-box-tales';
import vertigoPlaytest from './vertigo-playtest';

// Drafts appear under `npm start` only. The production build drops them
// entirely (webpack removes the dead require), so unpublished text never
// ships. To publish, import the post above and move it into `posts`.
// e.g. `: [require('./my-post').default]`
const drafts = process.env.NODE_ENV === 'production' ? [] : [];

const posts = [
  ...drafts,
  vertigoPlaytest,
  coachGingeToyBoxTales,
  coachGingeHalloween,
  coachGingeForKids,
  quietBambooUpdate,
  farshorePlaytest,
  theChinaYouHaventSeen,
  farshore,
  coachGinge,
  quietBamboo,
  podbrowser,
  vertigo,
]
  .slice()
  .sort((a, b) => (a.date < b.date ? 1 : -1));

export default posts;
